import React from "react";
import i18n from "i18next";

/* eslint-disable react/prop-types */
export function OneClick(base) {
  return {
    getConfig: function () {
      return {
        name: "OneClick",
        displayName: i18n.t("OneClick.PluginName"),
        category: "objects",
        flavor: "react",
        needsConfigModal: false,
        needsTextEdition: false,
        initialWidth: "480px",
        initialHeight: "270px",
        initialWidthSlide: "30%",
        initialHeightSlide: "30%",
        icon: "touch_app",
      };
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            basic: {
              __name: i18n.t("configuration"),
              icon: "link",
              buttons: {
                oneclick_edit: {
                  __name: i18n.t("Sound.Edit"),
                  type: "oneclick_edit",
                },
              },
            },
          },
        },
      };
    },
    getInitialState: function () {
      return {
        name: "IdealStudio",
      };
    },
    getRenderTemplate: function (state, props) {
      return (
        <div
          style={{ background: "#e9e9e9ad", width: "100%", height: "100%", borderRadius: "15px" }}
        />
      );
    },
  };
}
/* eslint-enable react/prop-types */
